
function newsletterSubmission() {
    const emailInput = document.getElementById('js-email');
    const submitbutton = document.getElementById('js-submitbutton');

    if (emailInput && submitbutton) {
        emailInput.addEventListener("keyup", function (e) {
            const emailInputSpotler = document.getElementById('field1881');
            if (emailInputSpotler) {
                emailInputSpotler.value = emailInput.value;
            }
        });
        
        submitbutton.addEventListener("click", function () {
            const submitbuttonSpotler = document.getElementById('field1887');

            if (emailInput.value !== '') {
                submitbuttonSpotler.click();
            }
        });        
    }
}

newsletterSubmission();